<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold">Puesto y dependencia</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <template v-if="personal.CatRamaDependencia">
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Dependencia</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="personal.CatRamaDependencia.CatDependencia.catInstancia.title"
                    rounded
                    readonly
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Instancia"
                  ></v-text-field>
                  <v-text-field
                    v-model="personal.CatRamaDependencia.CatDependencia.nombre"
                    rounded
                    readonly
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Nombre"
                  ></v-text-field>
                  <v-text-field
                    v-model="personal.CatRamaDependencia.ramaDependencia"
                    rounded
                    readonly
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Dirección"
                  ></v-text-field>
                  <template v-if="personal.CatSubArea">
                    <v-text-field
                      v-model="personal.CatSubArea.CatArea.nombre"
                      rounded
                      readonly
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Área"
                    ></v-text-field>
                    <v-text-field
                      v-model="personal.CatSubArea.nombre"
                      rounded
                      readonly
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Sub-área"
                    ></v-text-field>
                  </template>
                  <template v-else>
                    <v-text-field
                      value=""
                      rounded
                      readonly
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Área"
                    ></v-text-field>
                    <v-text-field
                      value=""
                      rounded
                      readonly
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Sub-área"
                    ></v-text-field>
                  </template>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </template>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Puesto</div>
          </v-col>
          <v-col cols="4" v-if="personal.CatPuestoDependencia">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-if="personal.CatPuestoDependencia.CatTipoPuesto"
                  v-model="personal.CatPuestoDependencia.CatTipoPuesto.title"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Tipo de Puesto"
                ></v-text-field>
                <v-text-field
                  v-else
                  value=""
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Tipo de Puesto"
                ></v-text-field>
                <v-text-field
                  v-model="personal.CatPuestoDependencia.catPuesto.puesto"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Puesto"
                ></v-text-field>
                <v-text-field
                  v-if="isAllowedToSeeRestrictedFields"
                  v-model="personal.plaza"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Plaza"
                ></v-text-field>
                <v-text-field
                  v-if="personal.CatTurno"
                  v-model="personal.CatTurno.title"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Turno"
                ></v-text-field>
                <v-text-field
                  v-else
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Turno"
                ></v-text-field>
                <v-textarea
                  v-model="personal.CatPuestoDependencia.funciones"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Funciones"
                  no-resize
                  rows="4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Datos de nuevo ingreso</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  v-model="ingresoAspirante"
                  label="Este elemento es de nuevo ingreso"
                  color="secondary"
                  hide-details
                  class="mt-0"
                  :loading="updatingAspirante"
                  @change="handleIngresoAspiranteChange"
                ></v-checkbox>
                <v-checkbox
                  v-model="reclutadoPolicial"
                  label="Este elemento inició como aspirante y fue reclutado como policía"
                  color="secondary"
                  :loading="updatingReclutado"
                  @change="handleReclutadoPolicialChange"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Sede y Comisaría</div>
          </v-col>
          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="selectedSede"
                  rounded
                  filled
                  dense
                  :items="sedes"
                  item-value="id"
                  background-color="primary"
                  color="secondary"
                  label="Sede"
                  @change="onSedeChange"
                >
                  <template v-slot:selection="{ item }">
                    {{ item.nombre || item.title || item.sede || 'Sin nombre' }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ item.nombre || item.title || item.sede || 'Sin nombre' }}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="personal.fk_idSubsede"
                  rounded
                  filled
                  dense
                  :items="subsedesFiltradas"
                  item-value="id"
                  item-text="nombre"
                  background-color="primary"
                  color="secondary"
                  label="Comisaría"
                  :disabled="!selectedSede"
                  :hint="!selectedSede ? 'Selecciona primero una sede' : ''"
                  persistent-hint
                />
              </v-col>
            </v-row>
          </v-col>
          <template v-if="isAllowedToSeeRestrictedFields">
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Grado Homologado</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="personal.fk_idCatGradoHomologado"
                    rounded
                    filled
                    dense
                    :items="tipoGradoHomologado"
                    item-value="id"
                    item-text="title"
                    background-color="primary"
                    color="secondary"
                    label="Grado Homologado"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Fecha de alta</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label="Fecha de alta"
                        :value="fechaAlta"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        filled
                        dense
                        color="secondary"
                        background-color="primary"
                      />
                    </template>
                    <v-date-picker v-model="selectedDate" @input="menu = false" no-title></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Número de empleado</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="personal.unidadAnalisisTactico"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Número de empleado"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="8">
              <div class="text-h6 font-weight-bold">Turno</div>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="nuevoTurno"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    :items="filteredTurnos"
                    item-value="id"
                    item-text="title"
                    item-color="secondary"
                    label="Turno"
                    placeholder="Selecciona un turno"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
          </template>
          <v-col cols="12" class="text-right">
            <TextButton :loading="loadingGuardar" color="secondary" class="primary--text mb-3" @click="saveAll">
              Guardar Cambios
            </TextButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import DateAdapter from '@src/utils/DateAdapter'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseTextInput from '../base/BaseTextInput.vue'
import TextButton from '../base/TextButton.vue'
import { PERFILES } from '@/perfiles.js'
import { API_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '@src/const'

export default {
  components: {
    BaseTextInput,
    TextButton,
  },

  props: {
    personal: {
      type: Object,
    },
  },

  data() {
    return {
      loadingGuardar: false,
      menu: false,
      selectedDate: this.personal.fechaIngresoEdoFza
        ? new DateAdapter(this.personal.fechaIngresoEdoFza, API_DATE_FORMAT).toUiSupportedFormat()
        : null,
      PERFILES,
      updatingAspirante: false,
      updatingReclutado: false,
      ingresoAspirante: false,
      reclutadoPolicial: false,
      selectedSede: null,
      subsedesFiltradas: [],
      nuevoTurno: null,
    }
  },

  computed: {
    ...mapGetters({ perfil: 'getPerfil' }),
    ...mapGetters('subsede', { subsedes: 'getSubsedes' }),
    ...mapGetters('sede', { sedes: 'getSedes' }),
    ...mapGetters('gradoHomologado', { tipoGradoHomologado: 'getGradoHomologado' }),
    ...mapGetters('turnos', { turnos: 'getTurnos' }),

    fechaAlta() {
      if (!this.selectedDate) {
        return ''
      }

      return new DateAdapter(this.selectedDate, VUETIFY_DATE_FORMAT).toHumanReadable()
    },

    filteredTurnos() {
      return this.turnos.filter((turno) => {
        return turno.id == 1 || turno.id == 2 || turno.id == 3
      })
    },

    isAllowedToSeeRestrictedFields() {
      const allowedProfiles = [
        PERFILES['Administrador IPH+'],
        PERFILES['Recursos Humanos'],
        PERFILES['RH_ADMINISTRADOR'],
        PERFILES['RH_TRAMITES ADMINISTRATIVOS'],
        PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION'],
        PERFILES['RH_REGISTRO DE PERSONAL'],
        PERFILES['DP_ADMINISTRADOR'],
        PERFILES['COMISARIA_CAPTURA'],
        PERFILES['COMISARIA_ADMINISTRADOR'],
      ]

      return allowedProfiles.includes(this.perfil)
    },
  },

  watch: {
    personal: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.ingresoAspirante = newVal.ingresoAspirante || false
          this.reclutadoPolicial = newVal.reclutadoPolicial || false

          if (newVal.CatTurno && newVal.CatTurno.id) {
            this.nuevoTurno = newVal.CatTurno.id
          }

          if (newVal.fk_idSubsede && this.subsedes.length > 0) {
            const subsede = this.subsedes.find((s) => s.id === newVal.fk_idSubsede)
            if (subsede && subsede.fk_idSede) {
              this.selectedSede = subsede.fk_idSede
              this.loadSubsedesBySede(subsede.fk_idSede)
            }
          }
        }
      },
    },
  },
  async mounted() {
    await Promise.all([this.fetchGradoHomologado(), this.fetchSedes(), this.fetchSubsedes(), this.fetchTurnos()])
  },

  methods: {
    ...mapActions('personal', ['updatePersonal', 'updateTurnoPersonal']),
    ...mapActions('gradoHomologado', ['fetchGradoHomologado']),
    ...mapActions('subsede', ['fetchSubsedes', 'fetchSubsedesBySede']),
    ...mapActions('sede', ['fetchSedes']),
    ...mapActions('turnos', ['fetchTurnos']),
    ...mapActions('aspirantes', ['updateAspiranteStatus', 'updateAspiranteReclutedToPolicia']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async onSedeChange(sedeId) {
      this.personal.fk_idSubsede = null

      if (!sedeId) {
        this.subsedesFiltradas = []
        return
      }

      await this.loadSubsedesBySede(sedeId)
    },

    async loadSubsedesBySede(sedeId) {
      try {
        await this.fetchSubsedesBySede({ id: sedeId })

        this.subsedesFiltradas = this.subsedes.filter((subsede) => subsede.fk_idSede === sedeId)
      } catch (error) {
        console.error('Error al cargar subsedes:', error)
        this.subsedesFiltradas = []
      }
    },

    async saveAll() {
      try {
        this.loadingGuardar = true

        const payload = {
          ...this.personal,
          fk_idCatGradoHomologado: this.personal.fk_idCatGradoHomologado,
          fechaIngresoEdoFza: this.selectedDate
            ? new DateAdapter(this.selectedDate, VUETIFY_DATE_FORMAT).toApiSupportedFormat()
            : this.personal.fechaIngresoEdoFza,
          unidadAnalisisTactico: this.personal.unidadAnalisisTactico,
          fk_idSubsede: this.personal.fk_idSubsede,
        }

        await this.updatePersonal(payload)

        if (this.nuevoTurno && this.nuevoTurno !== this.personal.CatTurno?.id) {
          await this.updateTurnoPersonal({
            idPersonal: this.personal.idPersonal,
            fk_idCatTurno: this.nuevoTurno,
          })
        }

        await this.$store.dispatch('personal/fetchPersonalById', this.personal.idPersonal)

        this.SET_SNACKBAR_MESSAGE('Cambios guardados exitosamente.')
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('No fue posible guardar los cambios.')
      } finally {
        this.loadingGuardar = false
      }
    },

    async handleIngresoAspiranteChange(value) {
      this.updatingAspirante = true
      try {
        await this.updateAspiranteStatus({ idPersonal: this.personal.idPersonal, ingresoAspirante: value })
      } catch (error) {
        if (error.response?.data?.error_code !== 500) {
          this.ingresoAspirante = !value
        }
        console.error('Error al actualizar ingreso aspirante:', error)
      } finally {
        this.updatingAspirante = false
      }
    },

    async handleReclutadoPolicialChange(value) {
      this.updatingReclutado = true
      try {
        await this.updateAspiranteReclutedToPolicia({ idPersonal: this.personal.idPersonal, reclutadoPolicial: value })
      } catch (error) {
        if (error.response?.data?.error_code !== 500) {
          this.reclutadoPolicial = !value
        }
        console.error('Error al actualizar reclutado policial:', error)
      } finally {
        this.updatingReclutado = false
      }
    },
  },
}
</script>
